import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../api";
import { reducerPaths } from "../../app/reducerPaths";

export const signinApi = createApi({
  reducerPath: reducerPaths.signinApi, // Unique key in Redux store
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    signin: builder.query({
      query: ({ payload }) => ({
        url: ``,
        method: "POST",
        body: payload,
      }),
    }),
    verifyOtpHandler: builder.query({
      query: ({ payload }) => ({
        url: ``,
        method: "POST",
        body: payload,
      }),
    }),
    logout: builder.mutation({
      query: ({ payload }) => ({
        url: "",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useSigninQuery, useVerifyOtpHandlerQuery, useLogoutMutation } =
  signinApi;

export const { useLazySigninQuery, useLazyVerifyOtpHandlerQuery } = signinApi;
